const { origin } = window.location

export default origin.includes('localhost') ? 'http://localhost:3040' : origin
